import { render, staticRenderFns } from "./ConditionalSwiper.vue?vue&type=template&id=01915593"
import script from "./ConditionalSwiper.vue?vue&type=script&lang=js"
export * from "./ConditionalSwiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports